import { maxLength, required } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import axios from "axios";
import CONFIG from "@/assets/js/config.js";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';

export default {
  data() {
    return {
      createAnswer: {
        description: '',
        remark: '',
        status: 0,
        files: []
      },
      submitted: false,
      submit_permission: false,
      disabled: false,
      CONFIG,
      pdfIcon,
      docIcon,
      pptIcon
    };
  },

  validations: {
    createAnswer: {
      description: {
        required,
        maxLength: maxLength(200)
      },
      remark: {
        maxLength: maxLength(5000)
      },
    }
  },

  computed: {
    ...mapGetters(["userType", "studentId"])
  },

  methods: {
    create() {
      if (this.disabled) return;
      this.disabled = true;
      this.submitted = true;
      this.submit_permission = false;
      if (this.$v.createAnswer.$invalid) {
        this.disabled = false;
        return;
      }

      let formData = new FormData();
      formData.append('description', this.createAnswer.description);
      formData.append('remark', this.createAnswer.remark);
      formData.append('status', this.createAnswer.status);
      formData.append('assignmentId', this.$route.params.id);
      this.createAnswer.files.forEach(fileObj => {
        formData.append('files[]', fileObj.file);
      });

      axios.post(`my/assignment/answer/create`, formData)
        .then(() => {
          this.changeSection();
          this.$notification.success("Assignment တင်ခြင်းအောင်မြင်ပါသည်။", {
            timer: 3,
            position: "bottomCenter"
          });
        })
        .catch((error) => {
          if (error && error.response && error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          } else if (error && error.response && error.response.status == 422) {
            const errors = error.response.data.errors;
            const field = Object.keys(errors)[0];
            const msg = errors[field][0];
            this.$notification.error(msg, {
              timer: 3,
              position: "bottomCenter",
            });
            return;
          }
          console.log("Create Answer API Error", error);
        })
        .finally(() => {
          this.disabled = false;
        });
    },

    chooseFiles(id) {
      document.getElementById(id).click();
    },

    onFileChange(e) {
      const selectedFiles = e.target.files;
      if (!selectedFiles || !selectedFiles.length) return;

      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];

        const fileExtension = file.name.split('.').pop().toLowerCase();

        if (!CONFIG.ASSIGNMENT.ALLOWED_FILE_TYPES.includes(file.type) || fileExtension === 'jfif') {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Type, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        if (file.size > CONFIG.ASSIGNMENT.MAX_FILE_SIZE) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Size, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }
        if (this.createAnswer.files.length >= CONFIG.ASSIGNMENT.MAX_FILE_COUNT) {
          this.$notification.error(CONFIG.ASSIGNMENT.ERROR.Max_Count, {
            timer: 3,
            position: "bottomCenter",
          });
          return;
        }

        const nameLower = file.name.toLowerCase();
        const exists = this.createAnswer.files.some(f => (f.name || '').toLowerCase() === nameLower);

        if (exists) {
          this.$notification.error(`"${file.name}" is already added.`, {
            timer: 3,
            position: "bottomCenter",
          });
          continue;
        }

        const fileObj = {
          file: file,
          name: file.name,
          type: file.type,
          data: null
        };
        this.createAnswer.files.push(fileObj);

        if (file.type.match(/image/i)) {
          const reader = new FileReader();
          reader.onload = () => {
            fileObj.data = reader.result;
          };
          reader.readAsDataURL(file);
        }
      }

      const inputEl = document.getElementById('answer-file');
      if (inputEl) inputEl.value = null;
    },

    removeFile(i) {
      const inputEl = document.getElementById('answer-file');
      if (inputEl) inputEl.value = null;
      this.createAnswer.files.splice(i, 1);
    },

    confirmRemoveFile(i) {
      if (this.disabled) return;
      const message = 'ဤ File ကို ဖျက်ရန် သေချာပါသလား?';
      if (window.confirm(message)) {
        this.removeFile(i);
      }
    },

    changeSection() {
      this.$emit('changeSection', 'AssignmentAnswerList');
    }
  },

  mounted() {

  },
};
